import {cloneDeep, filter, get, map, mapValues, merge, set} from 'lodash';

const initialState = {
    error: null,
    fetched: false,
    fetching: false,
    recordsToLock: null,
    lockedRecords: {},
    locallyLocked: {},
    loggedIn: false,
    recordLockCount: {},
};

const actions = {
    RECORD_LOCKING_LOCK_RECORD: (state, {component, serviceKey, recordId}) => set(
            cloneDeep(state),
            ['recordLockCount', component, serviceKey, recordId],
            get(state, ['recordLockCount', component, serviceKey, recordId], 0) + 1
        ),
    RECORD_LOCKING_UNLOCK_RECORD: (state, {component, serviceKey, recordId}) => set(
            cloneDeep(state),
            ['recordLockCount', component, serviceKey, recordId],
            get(state, ['recordLockCount', component, serviceKey, recordId], 1) - 1
        ),
    RECORD_LOCKING_SET_LOCKED: (state, {component, recordIds, serviceKey}) => set(
            merge(cloneDeep(state), {error: null, fetched: false, fetching: true}),
            ['recordsToLock', serviceKey, component],
            recordIds
        ),
    RECORD_LOCKING_UPDATE: (state, {lockedRecords, user}) => {
        const locallyLocked = mapValues(lockedRecords, (records) => map(
                filter(records, ({username}) => username === user),
                'recordId'
            ),
        );

        return set(
            set(merge(cloneDeep(state), {fetched: true, fetching: false}), 'lockedRecords', lockedRecords),
            'locallyLocked',
            locallyLocked
        );
    },
    RECORD_LOCKING_ERROR: (state, {error}) => merge(cloneDeep(state), {error, fetched: false, fetching: false}),
    RECORD_LOCKING_LOGIN: (state, {loggedIn}) => merge(cloneDeep(state), {loggedIn}),
    RECORD_LOCKING_RESET: (state) => merge(cloneDeep(initialState), {recordsToLock: cloneDeep(state.recordsToLock)}),
};

const reducer = (state = initialState, action) => (actions[action.type] ? actions[action.type](state, action) : state);

export default reducer;
